/**
 * @file data-layer for Google-tag-mangment
 *
 * This function pushes the required information to the dataLayer so that Google-tag-manager can access that.
 */

const dataLayer = {
	push: (data) => {
		window.dataLayer?.push(data);
	}
}

export default dataLayer;

